export const MAX_FREE = 5

const STORAGE_KEY = "ai_free_usage"

function today() {
	return new Date().toISOString().slice(0, 10)
}

export function getCount() {
	if (typeof window === "undefined") return 0

	try {
		const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}")
		return stored.date === today() ? (stored.count ?? 0) : 0
	} catch {
		return 0 // corrupted LS → reset
	}
}

export function increment() {
	const newCount = Math.min(getCount() + 1, MAX_FREE)
	localStorage.setItem(STORAGE_KEY, JSON.stringify({ date: today(), count: newCount }))
	return newCount
}

export function remaining() {
	return MAX_FREE - getCount()
}
